import * as angular from 'angular';

(function () {
    'use strict';
    angular.module('app').directive('pkpSearchBox', pkpSearchBox);

    function pkpSearchBox() {
        return {
            restrict: 'E',
            scope: {
                model: '='
            },
            link: function (scope, element, attrs) {
                scope.placeholder = attrs.placeholder;
                scope.id = attrs.id;
                scope.label = attrs.label;
                scope.labelClass = attrs.labelClass;
            },
            template: require('app/_directives/pkp-search-box.directive.html')
        };
    }
})();
